module.exports = __webpack_public_path__ + "img/35.083117e1.jpg";